import { toast } from 'react-hot-toast';

type BaseActions = 'create' | 'update' | 'delete';
type EnrollmentActions = BaseActions | 'request' | 'approve' | 'reject';

type EntityMessagesType = {
  tournament: Record<BaseActions, string>;
  team: Record<BaseActions, string>;
  pool: Record<BaseActions, string>;
  player: Record<BaseActions, string>;
  contact: Record<BaseActions, string>;
  enrollment: Record<EnrollmentActions, string>;
};

const entityMessages: EntityMessagesType = {
  tournament: {
    create: 'Tournament created successfully',
    update: 'Tournament updated successfully',
    delete: 'Tournament deleted successfully',
  },
  team: {
    create: 'Team created successfully',
    update: 'Team updated successfully',
    delete: 'Team deleted successfully',
  },
  pool: {
    create: 'Pool created successfully',
    update: 'Pool updated successfully',
    delete: 'Pool deleted successfully',
  },
  player: {
    create: 'Player added successfully',
    update: 'Player updated successfully',
    delete: 'Player removed successfully',
  },
  contact: {
    create: 'Contact request received successfully',
    update: 'Contact request updated successfully',
    delete: 'Contact request removed successfully',
  },
  enrollment: {
    create: 'Enrollment created successfully',
    update: 'Enrollment updated successfully',
    delete: 'Enrollment removed successfully',
    request: 'Enrollment request submitted successfully',
    approve: 'Enrollment approved successfully',
    reject: 'Enrollment rejected successfully',
  },
};

export type EntityType = keyof EntityMessagesType;
export type ActionType<E extends EntityType = EntityType> =
  keyof EntityMessagesType[E];

export function showSuccessToast<E extends EntityType>(
  entity: E,
  action: ActionType<E>
) {
  const message = entityMessages[entity][action];
  toast.success(message as string, {
    duration: 3000,
    position: 'top-right',
  });
}
